import { iframeResizer} from 'iframe-resizer';
import page from '../pages/page';

function initializeIframe() {
  if (window.location.pathname.indexOf("/customer-services") == -1) {
    return;
  }

  const iframe = document.querySelector(".cms-iframe-rsp");
  if (!iframe) {
    return;
  }

  iframe.style.height = 'auto';
  iframe.style.minHeight = '600px';

  if (typeof(iframeResizer) !== 'function') {
    // prevents thrown errors in unit test
    return;
  }
  iframeResizer({
    log:false,
    heightCalculationMethod: 'max',
    targetOrigin: '*',
    checkOrigin: true,
  }, '.cms-iframe-content');
}

page('body.cms-content-page-body', initializeIframe);

export {
  initializeIframe
};
